var map = {
	"./calendar.svg": "0CRW",
	"./data-trends-blue.svg": "wOdE",
	"./market.svg": "ANLU",
	"./online-blue.svg": "meHy",
	"./online-brown.svg": "Ed5S",
	"./social-dashboard-blue.svg": "hzxm",
	"./social-dashboard-brown.svg": "zBww",
	"./stand-out-blue.svg": "Di8y",
	"./target.svg": "yxjO",
	"./undraw_all_the_data_h4ki.svg": "PiIh",
	"./undraw_work_in_progress_uhmv.svg": "S+SR",
	"./work-together-blue.svg": "cgHv",
	"./work-together-brown.svg": "JMu8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YTUN";